import { render, staticRenderFns } from "./ValidasiKedatanganTruck.vue?vue&type=template&id=295fa351&scoped=true&"
import script from "./ValidasiKedatanganTruck.vue?vue&type=script&lang=js&"
export * from "./ValidasiKedatanganTruck.vue?vue&type=script&lang=js&"
import style0 from "./ValidasiKedatanganTruck.vue?vue&type=style&index=0&id=295fa351&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295fa351",
  null
  
)

export default component.exports